import React, {Component} from 'react';
import SideNav, {NavItem, NavIcon, NavText} from '@trendmicro/react-sidenav';
import {Link} from 'react-router-dom';
import NpsStatus from './NpsStatus';
class MmaLeftNav extends Component {
    constructor (props) {
        super(props);
        this.state = {
            expandedNav: false
        }
    }

    toggleSideNav = () => {
        this.setState({
            expandedNav: !this.state.expandedNav
        })
    }

    toggleSelection = currentPath => {
        return currentPath === this.props.location.pathname ? 'selectedMenu' : 'nonSelectedMenu';
    }

    render() {
        const {currentUser, location, history} = this.props;
        const overlayStyle = this.state.expandedNav ? {display:'block'} : {display: 'none'};
        const hostApiUrl = process.env.REACT_APP_HOST_API_URL;
        const communityProfileUrl = hostApiUrl + '/developer/mvc/user/communityProfile';
        const organizationUsersUrl = hostApiUrl + '/developer/mvc/organization/manageUsers';
        const displayOrgUsers = (currentUser.opa && currentUser.organization !== null && currentUser.organization.memberType==="CORPORATE") ? 'd-block' : 'd-none';
        const displayUpgradeAccount = (currentUser.organization && currentUser.organization.memberType==="PERSONAL") ? 'd-block' : 'd-none';
        return (
            <SideNav
                onSelect={(selected) => {
                    console.log(this.props)
                    const to = '/' + selected;
                    this.toggleSelection(to);
                    if (location.pathname !== to) {
                        history.push(to);
                    }
                }}
                className="sideNavigation bg-gray-dark"
            >
                <div className="overlay" style={overlayStyle}></div>
                <SideNav.Toggle className="sideNavMobileToggle" onClick={this.toggleSideNav} />
                <SideNav.Nav defaultSelected="home" className="sideNavWrapper">
                    <NavItem disabled className="sideNavUserDetail">
                    { currentUser.id &&
                        <NpsStatus {...this.props} />
                    }
                    </NavItem>
                    <NavItem disabled className="sideNavMmmaTextWrapper">
                        <NavText>
                            <p id="leftNavMMATab" className="sideNavMmmaText">MANAGE MY ACCOUNT</p>
                        </NavText>
                    </NavItem>
                    <NavItem eventKey="accountOverview" className={`sideNavItem ${this.toggleSelection('/accountOverview')}`} >
                        <NavIcon>
                            <i className="sideNavIcon fa fa-tachometer-alt" />
                        </NavIcon>
                        <NavText className="sideNavLink">
                        <Link id="leftNavAccOverview" to='/accountOverview' target="_self" className="navLinkText" >Account Overview</Link>
                        </NavText>
                    </NavItem>
                    <NavItem eventKey="manageSettings" className={`sideNavItem ${this.toggleSelection('/manageSettings')}`}>
                        <NavIcon>
                            <i className="fa fa-cog sideNavIcon" />
                        </NavIcon>
                        <NavText>
                            <Link id="leftNavSetting" to='/manageSettings' target="_self" className="navLinkText">Settings </Link>
                        </NavText>
                    </NavItem>
                    <NavItem eventKey="organizationUsers" className={`sideNavItem ${this.toggleSelection('/organizationUsers')} ${displayOrgUsers}`}>
                        <NavIcon>
                            <i className="fa fa-users sideNavIcon"/>
                        </NavIcon>
                        <NavText>
                            <a id="leftNavOrgUser" href={organizationUsersUrl} target="_self" className="navLinkText organizationUsers">Organization Users</a>
                        </NavText>
                    </NavItem>
                    <NavItem eventKey="upgradeIndividualAccount" className={`sideNavItem ${this.toggleSelection('/upgradeIndividualAccount')} ${displayUpgradeAccount}`}>
                        <NavIcon>
                            <i className="fa fa-users sideNavIcon" />
                        </NavIcon>
                        <NavText>
                            <Link id="leftNavUpgradepersonalUser" to='/upgradeIndividualAccount' target="_self" className="navLinkText">Upgrade Individual Account</Link>
                        </NavText>
                    </NavItem>
                    <NavItem eventKey="myApis" className={`sideNavItem ${this.toggleSelection('/myApis')}`}>
                        <NavIcon>
                            <i className="fa fa-code sideNavIcon" />
                        </NavIcon>
                        <NavText>
                            <Link id="leftNavMyAPI" to="/myApis" target="_self" className="navLinkText">My APIs</Link>
                        </NavText>
                    </NavItem>
                    <NavItem eventKey="myApps" className={`sideNavItem ${this.toggleSelection('/myApps')}`}>
                        <NavIcon>
                            <i className="fa fa-cloud-upload-alt sideNavIcon" />
                        </NavIcon>
                        <NavText>
                            <Link id="leftNavMyApps" to="/myApps" target="_self" className="navLinkText">My Apps</Link>
                        </NavText>
                    </NavItem>
                    <NavItem eventKey="communityProfile" className={`sideNavItem ${this.toggleSelection('/communityProfile')}`}>
                        <NavIcon>
                            <i className="fa fa-user sideNavIcon" />
                        </NavIcon>
                        <NavText>
                            <a id="leftNavCommunityProfile" href={communityProfileUrl}  className="navLinkText communityProfile">Community Profile</a>
                        </NavText>
                    </NavItem>
                </SideNav.Nav>
            </SideNav>
        )
    }
}

export default MmaLeftNav;



// WEBPACK FOOTER //
// ./src/manageMyAccount/MmaLeftNav.js